module.exports = __webpack_public_path__ + "img/bad-white.8da58e5e.svg";